// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"800":"9200f4d9","998":"9200f4d9"}[chunkId] + ".chunk.css";
};